import { NotificationProvider } from '@ipc/ipc-components';
import React from 'react';
import { Provider } from 'react-redux';
// import { ReactQueryDevtools } from 'react-query-devtools';
import { defaultLanguage, supportedLanguages } from '../../locales/locales';
import { store } from '../../store';
// import { isDev } from '../../utils/development/tools';
import AppContainer from './AppContainer';
import { AppIntlProvider } from './AppIntlProvider';
import ErrorBoundary from './errorBoundary/ErrorBoundary';
import { Theme } from './Theme';
import { SidebarProvider, UiProvider } from '../common/contexts';
import { LanguageProvider, LanguageRouting } from '../../externals/language';
import { Router, Route } from '../../externals/routing';

function languageRouting() {
  return (props) => <LanguageRouting {...props} AppContainer={AppContainer} />;
}

export const Root = () => (
  <Provider store={store}>
    {/* {isDev() && <ReactQueryDevtools initialIsOpen={false} />} */}
    <Theme>
      <LanguageProvider supportedLanguages={supportedLanguages} defaultLanguage={defaultLanguage}>
        <NotificationProvider>
          <SidebarProvider>
            <AppIntlProvider>
              <UiProvider>
                <Router basename={process.env.basePath}>
                  <ErrorBoundary>
                    <Route render={languageRouting()} />
                  </ErrorBoundary>
                </Router>
              </UiProvider>
            </AppIntlProvider>
          </SidebarProvider>
        </NotificationProvider>
      </LanguageProvider>
    </Theme>
  </Provider>
);

export default Root;
